export const webformTemplate = (ctx: any) => {
  return `<h2 class="formio-component form-headline"></h2>
<div class="${ctx.classes}" ref="webform" novalidate>${ctx.children}</div>`;
};
